import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import {
  AiOutlineCheck,
  AiOutlineInfoCircle,
  AiOutlineSwap,
} from "react-icons/ai";

import { FaSmile, FaUserFriends } from "react-icons/fa";
import { MdOutlineLeaderboard } from "react-icons/md";
import "./infobar.css";
import UniqueColorGraph from "./UniqueColorGraph";
import Challenge from "./Challenge";
function InfoBar({ gameState, nameToColor, hexToRgb, colorDiff, lastColor }) {
  const [displayed, setDisplayed] = useState(0);
  const [toggleLColor, setToggleLColor] = useState(false);
  useEffect(() => {
    // if(!localStorage.getItem('colordle-state')) setDisplayed(1);
  }, []);

  return (
    <>
      {displayed !== 0 && (
        <div className="modal-backdrop" onClick={() => setDisplayed(0)}></div>
      )}
      <div className="info-bar" style={{ textAlign: "right" }}>
        <button onClick={() => setDisplayed(displayed === 0 ? 4 : 0)}>
          <FaUserFriends style={{ fontSize: "1.5em" }} />
        </button>
        <button onClick={() => setDisplayed(displayed === 0 ? 1 : 0)}>
          <AiOutlineInfoCircle style={{ fontSize: "1.5em" }} />
        </button>
        <button onClick={() => setDisplayed(displayed === 0 ? 2 : 0)}>
          <MdOutlineLeaderboard style={{ fontSize: "1.5em" }} />
        </button>
        <div
          className="floating-panel"
          style={{
            display: displayed === 1 ? "inline" : "none",
          }}
        >
          {/* Header */}
          <h2 style={{ marginBottom: "0.25rem" }}>Colordle</h2>
          <p style={{ opacity: 0.7, fontSize: "0.9rem", marginBottom: "1rem" }}>
            A daily color guessing game by Ryan Tanenholz
          </p>
          
          {(() => {
            const now = new Date();
            const month = now.getMonth();
            const day = now.getDate();
            const year = now.getFullYear();
            if (year === 2025 && month === 11 && (day === 14 || day === 15)) {
              return (
                <p style={{ color: "#ff69b4", fontWeight: "bold", fontSize: "0.9em", textAlign: "center", margin: "0.5em 0" }}>
                  🎂 Happy Birthday Marina! 🎂
                </p>
              );
            }
            return null;
          })()}

          {/* How to Play */}
          <div style={{ background: "rgba(255,255,255,0.1)", padding: "0.75rem", borderRadius: "8px", marginBottom: "1rem" }}>
            <h4 style={{ margin: "0 0 0.5rem 0", fontSize: "0.95rem" }}>How to Play</h4>
            <p style={{ margin: 0, fontSize: "0.9rem", lineHeight: 1.5 }}>
              Guess the hidden color! The higher the percentage, the closer you are. 
              A new color appears every day.
            </p>
          </div>

          {/* Yesterday's Color */}
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "1rem" }}>
            {!toggleLColor ? (
              <button onClick={() => setToggleLColor(true)} style={{ fontSize: "0.85rem" }}>
                Reveal Yesterday's Color
              </button>
            ) : (
              <p style={{ margin: 0, fontWeight: 600 }}>
                Yesterday: {nameToColor(lastColor).name}
              </p>
            )}
          </div>

          {/* Resources */}
          <div style={{ fontSize: "0.85rem", marginBottom: "1rem" }}>
            <p style={{ margin: "0.5rem 0" }}>
              <strong>Need help?</strong>{" "}
              <a href="https://codepen.io/meodai/full/VMpNdQ/">Browse all colors</a>
            </p>
            <p style={{ margin: "0.5rem 0" }}>
              <strong>Suggest a daily color</strong>{" "}
              <a
                href="https://forms.gle/JW7K3vjFctDujJot7"
                target="_blank"
                rel="noopener noreferrer"
              >
                Help choose colors for future days
              </a>
            </p>
            <p style={{ margin: "0.5rem 0", opacity: 0.8 }}>
              Inspired by <a href="https://www.nytimes.com/games/wordle/index.html">Wordle</a> • 
              Colors from <a href="https://github.com/meodai/color-names">color-names</a>
            </p>
          </div>

          {/* Support */}
          <div style={{ background: "rgba(255,255,255,0.05)", padding: "0.75rem", borderRadius: "8px", marginBottom: "1rem", textAlign: "center" }}>
            <p style={{ margin: "0 0 0.5rem 0", fontSize: "0.85rem" }}>
              Enjoy Colordle? Consider supporting development:
            </p>
            <a href="https://venmo.com/u/Ryan-Tanenholz" style={{ fontWeight: 600 }}>
              Support via Venmo
            </a>
          </div>

          {/* Footer Links */}
          <div style={{ borderTop: "1px solid rgba(255,255,255,0.15)", paddingTop: "1rem", fontSize: "0.8rem", opacity: 0.7 }}>
            <p style={{ margin: "0.25rem 0" }}>
              <a href="mailto:rjtanenholz@gmail.com">Contact</a> • <a href="/privacy">Privacy Policy</a>
            </p>
            <p style={{ margin: "0.25rem 0" }}>
              Fun fact: <a href="https://twitter.com/hankgreen/status/1505261723716145156">Hank Green</a> had the same idea as me!
            </p>
          </div>

          {/* Playwire Badge */}
          <div style={{ marginTop: "1rem", textAlign: "center" }}>
            <a href="https://www.playwire.com/contact-direct-sales" rel="noopener noreferrer" target="_blank">
              <img 
                src="https://www.playwire.com/hubfs/Powered-by-Playwire-Badges/Ads-Powered-by-playwire-2021-standalone-small-white-300px.png" 
                alt="Ads Powered by Playwire" 
                style={{ width: "100px", height: "auto", opacity: 0.8 }}
              />
            </a>
          </div>

          {/* Close Button */}
          <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
            <button onClick={() => setDisplayed(0)}>Close</button>
          </div>
        </div>
        <div
          className="floating-panel"
          style={{
            display: displayed === 2 || displayed === 3 ? "inline" : "none",
          }}
        >
          <h1>Win Streak: {gameState.streak || "0"}</h1>
          {gameState.uniqueColorsGuessed && (
            <h1>
              Unique Colors Guessed:{" "}
              {gameState.uniqueColorsGuessed.length || "0"}
            </h1>
          )}
          <center
            style={{
              display: displayed === 3 ? "inline" : "none",
            }}
          >
            {displayed === 3 && (
              <UniqueColorGraph
                gameState={gameState}
                hexToRgb={hexToRgb}
                colorDiff={colorDiff}
                nameToColor={nameToColor}
              />
            )}{" "}
          </center>
          <p>
            <center>
              <button onClick={() => setDisplayed(0)}>Close</button>
            </center>
          </p>
        </div>
        <div
          className="floating-panel"
          style={{
            display: displayed === 4 ? "inline" : "none",
          }}
        >
          <p>
            <h1>Challenge your friends</h1>
          </p>
          <h2>Pick a color</h2>

          <Challenge />
          <p>
            <center>
              <button onClick={() => setDisplayed(0)}>Close</button>
            </center>
          </p>
        </div>
      </div>
    </>
  );
}

export default InfoBar;
